/**
 * HubSpot Integration Registration
 * Registers the HubSpot CRM integration with the integration registry
 */

import { integrationRegistry } from '../registry/IntegrationRegistry';
import { hubspotIntegrationFactory } from './HubSpotIntegrationFactory';

/**
 * Register HubSpot integration with the registry
 */
export function registerHubSpotIntegration(): void {
  integrationRegistry.register(
    'crm:hubspot',
    'HubSpot CRM',
    'crm',
    'hubspot',
    '1.0.0',
    hubspotIntegrationFactory
  );
  
  console.log('HubSpot CRM integration registered successfully');
}

/**
 * Unregister HubSpot integration from the registry
 */
export function unregisterHubSpotIntegration(): void {
  integrationRegistry.unregister('crm:hubspot');
  console.log('HubSpot CRM integration unregistered');
}

// Auto-register when module is imported
registerHubSpotIntegration();